module.exports = "//static.hsappstatic.net/LoginUI/static-1.14890/img/donut_desktop.svg"